// Refleja ResumenServicioEmpleado/VacacionesAllocation de
// apps/api/src/services/vacaciones-allocations.service.ts (Prompt BB-4(RH)).

export interface PeriodoNomina {
  n:             number;
  fechaInicio:   string;
  fechaFin:      string;
  diasOtorgados: number;
  diasTomados:   number;
}

// Saldo paralelo informativo (apps/api/src/services/saldo-nomina.ts).
export interface SaldoNomina {
  antiguedadAnios:   number;
  periodos:          PeriodoNomina[];
  adelantoPendiente: number;
  diasTotales:       number;
  diasTomados:       number;
  diasRestantes:     number;
}

export interface ResumenServicioEmpleado {
  usuarioId:          string;
  nombre:             string;
  fechaIngreso:       string | null;
  antiguedadAnios:    number | null;
  diasTotales:        number;
  diasTomados:        number;   // incluye adelantos
  diasRestantes:      number;   // puede ser negativo (adelantos)
  adelantoPendiente:  number;
  fechaIngresoNomina: string | null;
  nomina:             SaldoNomina | null;
}

export type EscenarioSaldo = 'leadsphere' | 'nomina';

export function fmtAnios(anios: number | null | undefined): string {
  if (anios === null || anios === undefined) return '—';
  return `${anios} año${anios === 1 ? '' : 's'}`;
}

export type AllocationEstado = 'vigente' | 'expirada';

export interface VacacionesAllocation {
  id:              string;
  usuario_id:      string;
  tipo_ausencia_id: string;
  fecha_inicio:    string;
  fecha_fin:       string;
  dias_otorgados:  number;
  dias_consumidos: number;
  estado:          AllocationEstado;
}
